import {AutoComplete, Button, Form, Select} from "antd";
import React, {CSSProperties, forwardRef, useEffect, useRef, useState} from "react";
import {request} from "../../util/request";
import {ObjTest} from "jzfz-web-utils";
import {FormInstance} from "antd/lib/form/hooks/useForm";
import {ModuleEnum} from "../../config/constant";
import {GLOBAL_STANDARD_API} from "../../config/api";


const { Option } = AutoComplete;

// 字段名称枚举
enum FieldNameEnum {
    customStandard = 'customStandard',
    customStandardArticle = 'customStandardArticle',
}


interface ConnectStandardFormProps {
    moduleType?: ModuleEnum;    // 模块类型
    className?: string;
    style?: CSSProperties;
    form: FormInstance;
    onChange?: (value: any) => void;
}


/**
 * 涉及规范表单组件
 * @param props
 * @constructor
 */
const StandardInput = (props: ConnectStandardFormProps, ref: any) => {
    const { moduleType, className, style, form, onChange = (values: any) => {} } = props;
    const [standardList, setStandardList] = useState([]);
    const [standardLoading, setStandardLoading] = useState<boolean>(false);
    const [articleList, setArticleList] = useState<any[]>([]);
    const [articleLoading, setArticleLoading] = useState<boolean>(false);
    const { getFieldsValue, getFieldValue, resetFields } = form;

    const timer = useRef<any>(null);


    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        }
    }, []);


    /**
     * 搜索规范
     */
    const searchStandard = (value: string) => {
        // 防抖
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            setStandardList([]);
            setStandardLoading(true);
            request('/nation/standard/selectListForLike', {keyword: value}, {baseURL: GLOBAL_STANDARD_API}).then((res: any) => {
                setStandardList(res.data || []);
            }).finally(() => {
                setStandardLoading(false);
            });
        }, 600);
    }


    /**
     * 过滤条文
     * @param list
     */
    const filter = (list: any[]): any[] => {
        if (moduleType !== ModuleEnum.standard) {
            return list;
        }
        const { pkid } = getFieldsValue();
        // 不能添加该条文本身
        return list.filter((v: any) => v.articlePkid !== pkid);
    }


    /**
     * 选中规范
     * @param value
     */
    const selectStandard = (values: any, option: any) => {
        const { value } = values;
        setArticleLoading(true);
        request('/nation/article/selectLike', {standardPkid: value}, {baseURL: GLOBAL_STANDARD_API}).then((res: any) => {
            resetFields([FieldNameEnum.customStandardArticle]);
            setArticleList(filter(res.data));
        }).finally(() => {
            setArticleLoading(false);
        });
    }


    /**
     * 清除规范下拉及表单值
     */
    const clearHandle = () => {
        resetFields([FieldNameEnum.customStandardArticle]);
        setArticleList([]);
    }


    /**
     * 添加
     */
    const add = () => {
        const values = getFieldsValue();
        const { label: standardName, value: standardPkid } = values[FieldNameEnum.customStandard];
        let data = values[FieldNameEnum.customStandardArticle].map((v: any) => ({
            standardName,
            standardPkid,
            articleCode: v.label,
            articlePkid: v.value,
            isExistStandard: 1,
        }))
        resetFields([FieldNameEnum.customStandard, FieldNameEnum.customStandardArticle]);
        onChange(data);
    }


    return (
        <div className={className} style={style}>
            <div className="flexic">
                <Form.Item name={FieldNameEnum.customStandard} noStyle>
                    <Select
                        className="standard-form-input-name"
                        placeholder="规范名称/规范号"
                        showSearch
                        allowClear
                        filterOption={false}
                        labelInValue
                        loading={standardLoading}
                        onSearch={searchStandard}
                        onSelect={selectStandard}
                        onClear={clearHandle}
                    >
                        {standardList.map((v: any, i: number) => (
                            <Option key={i} value={v.pkid} label={`${v.standardName} ${v.standardCode}`}>{`${v.standardName}${v.standardCode}`}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <span className="dashes-line"></span>
                <Form.Item noStyle shouldUpdate>
                    {() => (
                        <Form.Item name={FieldNameEnum.customStandardArticle} noStyle initialValue={[]}>
                            <Select
                                className="standard-form-input-article"
                                mode="multiple"
                                placeholder="条文"
                                allowClear
                                optionFilterProp="label"
                                filterOption={(inputValue: string, option: any) => {
                                    const { label } = option;
                                    return (label || '').trim().startsWith(inputValue);
                                }}
                                disabled={articleLoading || !getFieldValue(FieldNameEnum.customStandard)}
                                labelInValue={true}
                            >
                                {articleList.map((v: any, i: number) => (
                                    <Option key={i} value={v.articlePkid} label={v.articleCode}>{v.articleCode}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}
                </Form.Item>
                <Form.Item shouldUpdate noStyle>
                    {() => (
                        <Button
                            className="confirm-add-btn"
                            type="primary"
                            disabled={!ObjTest.isNotEmptyArray(getFieldValue(FieldNameEnum.customStandardArticle))}
                            onClick={add}
                        >确认添加</Button>
                    )}
                </Form.Item>
            </div>
        </div>
    )
}


export default forwardRef(StandardInput);
